"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgNoSignal = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_NO-SIGNAL", width: "1em", height: "1em", viewBox: "0 0 16 13" }, props),
    React.createElement("path", { d: "M15.682 3.931c.42.37.418 1.033.03 1.439-.388.405-1.013.401-1.438.04a9.882 9.882 0 0 0-2.135-1.392L9.8 5.368c1.13.273 2.168.799 3.056 1.517.435.351.432 1.017.044 1.423-.387.404-1.01.397-1.457.066a5.76 5.76 0 0 0-5.59-.728L1.502 10.16a1 1 0 1 1-1-1.732L14.497.347a1 1 0 0 1 1 1.732l-1.287.743c.518.331 1.01.702 1.472 1.11ZM10.777 1.34 7.764 3.08C5.476 3.135 3.38 4 1.726 5.41 1.3 5.77.676 5.774.289 5.37-.1 4.964-.102 4.302.318 3.931 2.393 2.102 5.073 1 8 1c.956 0 1.886.118 2.777.34Z" }),
    React.createElement("path", { d: "m8.703 12.696 1.428-1.493c.37-.388.374-1.014-.08-1.3a3.828 3.828 0 0 0-4.102 0c-.455.286-.45.912-.08 1.3l1.429 1.493a.963.963 0 0 0 1.405 0Z" }))); };
exports.default = SvgNoSignal;
